import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@lib/auth';

export function AdminLayout(): JSX.Element {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-12">
        <div className="w-8 h-8 border-4 border-ybh-yellow/30 border-t-ybh-yellow rounded-full animate-spin" />
      </div>
    );
  }

  if (user?.role !== 'admin') {
    return <Navigate to="/scorecard" replace />;
  }

  return <Outlet />;
}
